export const filterMonthlyDataByCamera = (monthlyData, cameraId, targetValue) => {

    if (monthlyData.length === 0) {
        return [];
    }

    let filteredData = [];

    if (cameraId === 'All') {
        filteredData = monthlyData;
    } else {
        for (let i = 0; i < monthlyData.length; i++) {
            const row = monthlyData[i];
            if (row.camera_id === cameraId) {
                filteredData.push(row);
            } else if (row.camera_id === null) {
                filteredData.push(row);
            } else {
                let hasMonth = filteredData.some(monthData => monthData.month === row.month);

                if (!hasMonth) {
                    const emptyMonth = {
                        'year': row.year,
                        'month': row.month,
                        'total_count': 0
                    }
                    filteredData.push(emptyMonth);
                }
            }
        }
    }


    const tempAggregation = new Map();

    filteredData.forEach(d => {
        const month = d.month;
        const totalValue = parseInt(d[targetValue]) || 0;

        if (!tempAggregation.has(month)) {
            tempAggregation.set(month, {
                [targetValue]: 0,
                'year': d.year,
                'hw_id': d.hw_id,
                'camera_id': d.camera_id
            });
        }


        const monthData = tempAggregation.get(month);
        monthData[targetValue] += totalValue;
    });


    const aggregatedData = [];

    for (const [monthNum, monthValue] of tempAggregation) {
        aggregatedData.push({
            year: monthValue.year,
            month: parseInt(monthNum),
            hw_id: monthValue.hw_id,
            camera_id: monthValue.camera_id,
            [targetValue]: monthValue[targetValue]
        });
    }    
    return aggregatedData;
    
};

export const filterWeeklyDataByCamera = (weeklyData, cameraId, targetValue) => {
    if (weeklyData.length === 0) {
        return []
    }

    let filteredData = [];

    if (cameraId === 'All') {
        filteredData = weeklyData;
    } else {
        for (let i = 0; i < weeklyData.length; i++) {
            const row = weeklyData[i];
            if (row.camera_id === cameraId) {
                filteredData.push(row);
            } else if (row.camera_id === null) {
                filteredData.push(row);
            } else {
                let hasWeek = filteredData.some(weekData => weekData.week === row.week);

                if (!hasWeek) {
                    const emptyMonth = {
                        'year': row.year,
                        'month': row.month,
                        'week_start_date': row.week_start_date,
                        'hw_id': row.hw_id,
                        'camera_id': row.camera_id,
                        'total_count': 0
                    }
                    filteredData.push(emptyMonth);
                }
            }
        }

    }

    const tempAggregation = new Map();

    filteredData?.forEach(d => {
        const week = d.week;
        const totalValue = parseInt(d[targetValue]);

        if (!tempAggregation.has(week)) {
            tempAggregation.set(week, {
                [targetValue]: 0,
                'year': d.year,
                'week_start_date': d.week_start_date,
                'hw_id': d.hw_id,
                'camera_id': d.camera_id
            });
        }

        const weekData = tempAggregation.get(week);
        weekData[targetValue] += totalValue;
    });

    const aggregatedData = [];

    for (const [weekNum, weekValue] of tempAggregation) {
        aggregatedData.push({
            year: weekValue.year,
            week: parseInt(weekNum),
            week_start_date: weekValue.week_start_date,
            hw_id: weekValue.hw_id,
            camera_id: weekValue.camera_id,
            [targetValue]: weekValue[targetValue]

        });
    }

    return aggregatedData;

};

export const filterDailyDataByCamera = (dailyData, cameraId, targetValue) => {
    if (dailyData.length === 0) {
        return []
    }

    let filteredData = [];

    if (cameraId === 'All') {
        filteredData = dailyData;
    } else {
        for (let i = 0; i < dailyData.length; i++) {
            const row = dailyData[i];
            if (row.camera_id === cameraId) {
                filteredData.push(row);
            } else if (row.camera_id === null) {
                filteredData.push(row);
            } else {
                let hasDay = filteredData.some(dayData => dayData.day_number === row.day_number);

                if (!hasDay) {
                    const emptyMonth = {
                        'day_number': row.day_number,
                        'day': row.day,
                        'hw_id': row.hw_id,
                        'camera_id': row.camera_id,
                        'total_count': 0
                    }
                    filteredData.push(emptyMonth);
                }
            }
        }

    }

    const tempAggregation = new Map();

    filteredData?.forEach(d => {
        const dayNumber = d.day_number;
        const dayName = d.day;
        const dailyValue = parseInt(d[targetValue]);

        if (!tempAggregation.has(dayNumber)) {
            tempAggregation.set(dayNumber, {
                [targetValue]: 0,
                'day': dayName,
                'hw_id': d.hw_id,
                'camera_id': d.camera_id
            });
        }

        const dayData = tempAggregation.get(dayNumber);
        dayData[targetValue] += dailyValue;

    });

    const aggregatedData = [];

    for (const [dayNum, dayValue] of tempAggregation) {
        aggregatedData.push({
            day_number: parseInt(dayNum),
            day: dayValue.day,
            hw_id: dayValue.hw_id,
            camera_id: dayValue.camera_id,
            [targetValue]: dayValue[targetValue]
        });
    }
    return aggregatedData;
};

export const getTotalForPeriod = (data, selectedPeriod, periodName, targetValue ) => {
    const row = data.find(d => d[periodName] === selectedPeriod);
    if (row) {
        return row[targetValue];
    } else {
        return 0;
    }
};

export const getPercentageIncrease = (data, selectedPeriod, periodName, targetValue) => {
    const currentIndex = data.findIndex(d => d[periodName] === selectedPeriod);
    const previousIndex = currentIndex - 1;
    if (previousIndex < 0) {
        return 0;
    }
    const currentTotal = data[currentIndex][targetValue];
    const previousTotal = data[previousIndex][targetValue];
    if (previousTotal > 0) {
        const perIncrease = ((currentTotal - previousTotal) / previousTotal) * 100;
        return perIncrease.toFixed(2);
    } else {
        return 100;
    }
};

export const getYearlyTotal = (data, targetValue) => {
    const total = data.reduce((sum, d) => sum + (parseInt(d[targetValue]) || 0), 0);
    return total
};

export const checkForEmptyData = (data) => {
    let hasData = false;

    for (let i = 0; i < data.length; i++) {
        const row = data[i];

        if (row.total_count > 0) {
            hasData = true;
        }
    }
    return hasData;
}